// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__JS8-w","labelWrapper":"Checkbox_labelWrapper__eyLlZ","switch":"Checkbox_switch__XM0gD","slider":"Checkbox_slider__qrnEh"};